import { defineComponent as _defineComponent } from 'vue'

import Icon from "@/components/widgets/icons/Icon.vue"
import TeamMemberCard from "@/modules/Missions/components/TeamMemberCard/TeamMemberCard.vue"
import {
  MissionLifecycleFragmentFragment,
  ConsultantMissionLifecycle,
  ClientMissionLifecycleFragmentFragment,
} from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamMembers',
  props: {
    mission: null
  },
  setup(__props: any) {



return { __sfc: true,Icon, TeamMemberCard }
}

})